// Selectors
import { ApplicationState } from '../../store';


export const dashboardSelector = (state: ApplicationState) => state.dashboardState

